/* SPEC-509 — the two feeds behind the ONE Alerts badge: critical findings in this login's
 * remit (SPEC-466, unchanged) and unread updates (the old bell). `config/shell.alertsBadge`
 * turns them into the badge; this hook only reads them. Disabled (no polling) when the login
 * has no Alerts page. */
import { useEffect } from 'react';
import { useApi } from './useApi';
import { fetchAgentRemits } from '@/lib/api';
import { useUpdatesUnread } from './useUpdates';
import type { AlertsFeeds } from '@/config/shell';

export function useAlertsFeeds(enabled: boolean): AlertsFeeds {
  const remits = useApi(fetchAgentRemits, [], { refreshInterval: 120_000, enabled });
  const refreshRemits = remits.refresh;
  useEffect(() => {
    // The Alerts page fires this after an acknowledge/dismiss, so the badge does not lag.
    const onChange = () => refreshRemits();
    window.addEventListener('suryaiq:alerts-changed', onChange);
    return () => window.removeEventListener('suryaiq:alerts-changed', onChange);
  }, [refreshRemits]);
  const updates = useUpdatesUnread(enabled);
  return {
    critical: !remits.error && typeof remits.data?.critical_new_count === 'number'
      ? remits.data.critical_new_count : null,
    criticalError: !!remits.error,
    updatesUnread: updates.unread,
    updatesError: updates.error,
  };
}
